import { GenericAbortSignal } from 'axios';
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from 'components/MprcAutoComplete';
import { IAutoCompleteProps } from "components/MprcAutoComplete/AutoComplete";
import { ModeratorChannelAutoCompleteDataModel } from 'components/MprcAutoComplete/AutoCompleteDataModel';
import { isCanceledError, useCoreApi } from 'providers/CoreApiProvider';
import React from 'react';

////////////////////////////////////////////////////////////////////////////

interface Props extends Omit<IAutoCompleteProps, 'onGetSuggestions'> {
    channelId?: string;
    selectedItems: ModeratorChannelAutoCompleteDataModel[];
    onChange: (item: (AutoCompleteDataModel | ModeratorChannelAutoCompleteDataModel)[]) => void;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de canais
 * @param props
 */
export const ModeratorChannelAutoComplete: React.FC<Props> = (props) => {

    const api = useCoreApi();

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<ModeratorChannelAutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();

        return new Promise<AutoCompleteSuggestions<ModeratorChannelAutoCompleteDataModel>>((resolve) => {
            api.v1.knowledgeSuggestions.moderatorsChannel({
                channelId: props.channelId ?? null,
                searchText: searchText,
                pageNumber: pageNumber,
                pageSize: pageSize,
            }, { signal })
                .then(result => {
                    resolve({
                        items: result.data.items,
                        totalRows: result.data.totalRows
                    });
                })
                .catch(error => {
                    if (!isCanceledError(error)) {
                        resolve({ items: [], totalRows: 0 });
                        if (props.onError) props.onError(error);
                    }
                });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcAutoComplete
            {...props}
            onGetSuggestions={getSuggestions}
        />
    );
};
